import { MetaPageConfig } from "../configs/configs.types";

export function getMetaPageConfig(config: MetaPageConfig | null, variant: string): MetaPageConfig | null {
  if (!config) {
    return null;
  }

  if (config.variants && config.variants[variant]) {
    return {
      title: config.variants[variant].title,
      description: config.variants[variant].description,
      metaDescription: config.variants[variant].metaDescription,
      variants: config.variants
    };
  }

  return config;
}
